import React from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { ErrorBoundaryFallback } from '../../ErrorBoundaryFallback';

import { ErrorBoundaryPropsWithComponent } from 'react-error-boundary';

export const ErrorBoundary = ({
  FallbackComponent = ErrorBoundaryFallback,
  ...otherProps
}: ErrorBoundaryProps) => (
  <ReactErrorBoundary FallbackComponent={FallbackComponent} {...otherProps} />
);

interface ErrorBoundaryProps extends Omit<ErrorBoundaryPropsWithComponent, 'FallbackComponent'>,
  Partial<Pick<ErrorBoundaryPropsWithComponent, 'FallbackComponent'>> {
  children: React.ReactNode;
}
